import { FC } from "react";

import { PrescriberInfoProps } from "./types";
import { CASE_CATEGORY, DEFAULT_DRUG_NAME } from "src/constants/cases";
import { format, parse} from 'date-fns';
const ShowPrescriberInformation: FC<PrescriberInfoProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes, case_attributes, category, shipments_attributes } = getValues();

  return (
    <div className="card my-3">
      <div className="card-header">
        <h4 className="m-0">Prescription Information</h4>
      </div>
      <div className="card-body">
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12 mb-2 mb-md-0">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Drug:</label>
              </div>
              <div className="col-6">
                {DEFAULT_DRUG_NAME}
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Benefits being requested:</label>
              </div>
              <div className="col-6">
                <p>{category ? CASE_CATEGORY[category as ("rx" | "med" | "medrx")] : "N/A"}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12 mb-2 mb-md-0">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Schedule Date of Service:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.scheduled_date_of_service ? format(parse(prescription_attributes.scheduled_date_of_service, "yyyy-MM-dd", new Date()), 'MM/dd/yyyy') : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Injection Site:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.injection_site}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Quantity:</label>
              </div>
              <div className="col-6">
                <p>N/A</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Diagnosis Code (ICD):</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.diagnosis_code ? prescription_attributes.diagnosis_code.join(", ") : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Written Date:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.written_date ? prescription_attributes.written_date  : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Ship to:</label>
              </div>
              <div className="col-6">
                <p>
                  {case_attributes && case_attributes.ship_to ? 
                    (
                      case_attributes.ship_to === "other" && shipments_attributes ? 
                        `${shipments_attributes[0].ship_to_street}, ${shipments_attributes[0].ship_to_suite ? `${shipments_attributes[0].ship_to_suite},` : ""} ${shipments_attributes[0].ship_to_city}, ${shipments_attributes[0].ship_to_state}, ${shipments_attributes[0].ship_to_zip}`
                      : case_attributes.ship_to
                    )
                    : 'N/A'
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Directions:</label>
              </div>
              <div className="col-6">
                <p>N/A</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label">Notes:</label>
              </div>
              <div className="col-6">
                <p>{prescription_attributes && prescription_attributes.note ? prescription_attributes.note : 'N/A'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowPrescriberInformation;
